// // export const API_BASE_URL = "http://127.0.0.1:8000";
//export const API_BASE_URL = "http://52.34.26.10:8000";
// // export const API_BASE_URL = "http://192.168.0.249:8000";

// const getApiBaseUrl = () => {
//     const hostname = window.location.hostname;
//     console.log("hostname::", hostname)
//     switch (hostname) {
//         //case '127.0.0.1':
//         case 'localhost':
//             console.log("Matched localhost");
//             return 'http://127.0.0.1:8000';
//         case 'test-sbem-webapp.s3-website-us-east-1.amazonaws.com':
//             console.log("Matched test-sbem-webapp");
//             return 'http://52.34.26.10:8000';
//         case 'prod-sbem-webapp.s3-website-us-east-1.amazonaws.com':
//             console.log("Matched prod-sbem-webapp");
//             return 'http://34.210.253.28:8000';
//         case 'https://portal.sbemsolutions.com':
//             console.log("Matched portal.sbemsolutions.com");
//             return 'http://34.210.253.28:8000';
//         default:
//             console.log("Unknown hostname:", hostname);
//             throw new Error(`Unknown hostname: ${hostname}`);
//     }
// };

//export const API_BASE_URL = getApiBaseUrl();REACT_APP_API_BASE_URL
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const WEB_APP_URL = process.env.REACT_APP_WEB_URL;
export const SECRET_KEY = "ROCK-N-ROLL";
export const PAGE_SIZE = 25;
export const TYPE_SUCCESS = "success";
export const TYPE_INFO = "info";
export const TYPE_FAIL = "fail";
export const READER = "reader";
export const ADMIN = "admin";
export const SUPER_ADMIN = "super admin";
export const CONFIG_SERVICE = "config_service";

export const INTERVAL = 3000;
export const SAMPLE_FILE_URL = "https://test-sbem-webapp.s3.amazonaws.com/sample-csv/";

export const emailPattern = new RegExp(
    /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
);
export const PIN_CODE_PATTERN = new RegExp(
    /^[1-9][0-9]{5}$/
);
export const PHONE_NUMBER_PATTERN = new RegExp(
    /^(?:(?:\+|0{0,2})91(\s*[-]\s*)?|[0]?)?[789]\d{9}$/
);
export const passwordMatchPattern = new RegExp(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/);
export const GOOGLE_MAP_API_KEY = "AIzaSyBjfzI2CKzGEPYy558uhoxzcN23uiTrTP4";
export const OHT_DEVICE_TYPE = "OHT";
export const OHT_READINGS_PAGENAME = "Over Head Tank Readings";
export const FLOW_READINGS_PAGENAME = "Flow Readings";
export const PRESSURE_READINGS_PAGENAME = "Pressure Readings";
export const LEVEL_READINGS_PAGENAME = "Level Readings";
export const SYSTEM_ALL_TYPE_LIST = [
    { value: "amr systems", label: "Amr Systems" },
    { value: "ami systems", label: "Ami Systems" },
    { value: "shut on/off prepaid", label: "Shut ON/OFF Prepaid" },
    { value: "shut on/off postpaid", label: "Shut ON/OFF Postpaid" },
];
export const DEVICE_ALL_TYPE_LIST = [
    { value: "Flow", label: "Flow" },
    { value: "Pressure", label: "Pressure" },
    { value: "Level", label: "Level" },
    { value: "Temperature", label: "Temperature" },
    { value: "Over Head Tank", label: "Over Head Tank" }
];
export const DEVICE_TYPE_NAME_FLOW = "Flow";
export const DEVICE_TYPE_NAME_PRESSURE = "Pressure";
export const DEVICE_TYPE_NAME_LEVEL = "Level";
export const DEVICE_TYPE_NAME_TEMPERATURE = "Temperature";
export const DEVICE_TYPE_NAME_OVER_HEAD_TANK = "Over Head Tank";
export const FLOW_UNIT_TYPES = [
    { value: "m³", label: "M³" },
    { value: "liter", label: "Liter" }
];
export const PRESSURE_UNIT_TYPES = [
    { value: "bar", label: "Bar" },
    { value: "kg/cm²", label: "Kg/cm²" },
    { value: "mmh2o", label: "mmH2O" }
];
export const LEVEL_UNIT_TYPES = [
    { value: "meter", label: "Meter" },
    { value: "mm", label: "MM" }
];
export const TEMPERATURE_UNIT_TYPES = [
    { value: "°c", label: "°C" },
    { value: "°f", label: "°F" }
];

export const AMI_FLOW_DEIVE_TYPE= [
    { value: "153RWM", label: "153RWM" },
    { value: "151BO", label: "151BO" },
    { value: "153UIF", label: "153UIF" },
    { value: "151MFMP", label: "151MFMP" },
    { value: "153UCW", label: "153UCW" }
];

export const AMR_FLOW_DEVICE_TYPE = [
    { value: "153RWM", label: "153RWM" },
];

export const REMOTE_FLOW_DEVICE_TYPE = [
    { value: "153RWM", label: "153RWM" },
];

export const SYSTEM_TYPE_AMR_SYSTEMS = "Amr Systems";
export const SYSTEM_TYPE_AMI_SYSTEMS = "Ami Systems";
export const SYSTEM_TYPE_SHUT_ON_OFF_PREPAID = "Shut ON/OFF Prepaid";
export const SYSTEM_TYPE_SHUT_ON_OFF_POSTPAID = "Shut ON/OFF Postpaid";
export const SYSTEM_TYPE_REMOTE_CONFIGURATION = "Ami + Remote Configuration";
